"use strict";

module.exports = function (props) {
  var s = "";

  for (var key in props) s += `${key}: ${props[key].toString()}; `;

  return s;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImZvcm1hdFN0eWxlLmpzIl0sIm5hbWVzIjpbIm1vZHVsZSIsImV4cG9ydHMiLCJwcm9wcyIsInMiLCJrZXkiLCJ0b1N0cmluZyJdLCJtYXBwaW5ncyI6Ijs7QUFBQUEsTUFBQUEsQ0FBT0MsT0FBUEQsR0FBaUIsVUFBVUUsS0FBVixFQUFVQTtBQUN6QixNQUFJQyxDQUFBQSxHQUFJLEVBQVI7O0FBRUEsT0FBSyxJQUFJQyxHQUFULElBQWdCRixLQUFoQixFQUNFQyxDQUFBQSxJQUFBQSxHQUFRQyxHQUFBQSxLQUFRRixLQUFBQSxDQUFNRSxHQUFORixDQUFBQSxDQUFXRyxRQUFYSCxFQUFXRyxJQUEzQkY7O0FBR0YsU0FBT0EsQ0FBUDtBQUFPQSxDQVBUSCJ9